const ParquetIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="participator"
  >
    <title>a-icons / 32px / services / parksman</title>
    <g
      id="a-icons-/-32px-/-services-/-parksman"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M31.5,0 C31.7453333,0 31.9495802,0.176987654 31.9919396,0.410161866 L32,0.5 L32,31.5 C32,31.7453333 31.8230123,31.9495802 31.5898381,31.9919396 L31.5,32 L4.974,32 L4.945,32.028 L4.917,32 L0.5,32 C0.254666667,32 0.0504197531,31.8230123 0.00806035665,31.5898381 L0,31.5 L0,0.5 C0,0.254666667 0.176987654,0.0504197531 0.410161866,0.00806035665 L0.5,0 L31.5,0 Z M31,22.499 L22.499,31 L31,31 L31,22.499 Z M20.255,16.718 L5.974,31 L12.822,31 L23.68,20.143 L20.255,16.718 Z M9.52,19.191 L1.019,27.692 L1,27.674 L1,31 L4.56,31 L12.944,22.615 L9.52,19.191 Z M20.665,24.571 L14.236,31 L21.085,31 L24.089,27.995 L20.665,24.571 Z M31,14.235 L21.372,23.864 L24.796,27.288 L31,21.085 L31,14.235 Z M11.992,8.455 L1,19.447 L1,26.297 L15.417,11.88 L11.992,8.455 Z M22.614,6.097 L10.227,18.484 L13.651,21.908 L26.038,9.521 L22.614,6.097 Z M31,5.974 L20.962,16.011 L24.387,19.436 L31,12.821 L31,5.974 Z M3.853,8.331 L1,11.185 L1,18.033 L7.277,11.756 L3.853,8.331 Z M26.296,1 L19.447,1 L12.699,7.748 L16.124,11.173 L26.296,1 Z M18.033,1 L11.185,1 L4.561,7.624 L7.984,11.049 L18.033,1 Z M9.77,1 L1,1 L1,9.771 L9.77,1 Z M31,1 L27.71,1 L23.321,5.39 L26.745,8.814 L31,4.56 L31,1 Z"
        id="Shape"
        fill={color || '#00008F'}
      ></path>
    </g>
  </svg>
);

export default ParquetIcon;
